import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const FormsApi = createApi({
	reducerPath: "Forms",
	baseQuery: fetchBaseQuery({
		baseUrl: process.env.REACT_APP_BACKEND2_URL,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			return headers;
		},
		credentials: "include",
	}),
	endpoints: (builder) => ({
		getAllforms: builder.query({
			query: (val) => {
				const page = val.page ?? 1;
				const limit = val.limit ?? 10;
				const sortBy = val.sortby ? `&sortBy=${val.sortby}` : "";
				const sortOrder = val.sortorder ? `&sortOrder=${val.sortorder}` : "";
				const search = val.search ? `&search=${val.search}` : "";
				const isActive =
					val.isActive !== undefined ? `&isActive=${val.isActive}` : "";
				const queryString = val.queryString ? `&${val.queryString}` : "";

				return `/v1/formDefinitions?page=${page}&limit=${limit}${search}${sortBy}${sortOrder}${queryString}${isActive}`;
			},
		}),
		getSpecificForm: builder.query({
			query: (id) => `/v1/formDefinitions/${id}`,
		}),
		addForm: builder.mutation({
			query: (val) => ({
				url: `/v1/formDefinitions`,
				method: "POST",
				body: val,
			}),
		}),
		editForm: builder.mutation({
			query: ({ val, id }) => ({
				url: `/v1/formDefinitions/${id}`,
				method: "PATCH",
				body: val,
			}),
		}),
		deleteForm: builder.mutation({
			query: (id) => ({
				url: `/v1/formDefinitions/${id}`,
				method: "DELETE",
			}),
		}),
		getAllformsSubmission: builder.query({
			query: (val) => {
				const page = val.page ?? 1;
				const limit = val.limit ?? 10;
				const sortBy = val.sortby ? `&sortBy=${val.sortby}` : "";
				const sortOrder = val.sortorder ? `&sortOrder=${val.sortorder}` : "";
				const search = val.search ? `&search=${val.search}` : "";
				const queryString = val.queryString
					? `${val.queryString}&status=submitted`
					: "&status=submitted";

				return `/v1/formSubmissions?page=${page}&limit=${limit}${search}${sortBy}${sortOrder}${queryString}`;
			},
		}),
		getSingleFormSubmission: builder.query({
			query: (id) => `/v1/formSubmissions/${id}`,
		}),
		createFormSubmissionVersion: builder.mutation({
			query: ({ id, formData, status }) => ({
				url: `/v1/formSubmissions/${id}/version`,
				method: "POST",
				body: { formData, status },
			}),
		}),
		createSupervisorFormSubmission: builder.mutation({
			query: ({ taskId, formId, fields }) => ({
				url: `/v1/formSubmissions/supervisor`,
				method: "POST",
				body: { taskId, formId, fields },
			}),
		}),
	}),
});

export const {
	useGetAllformsQuery,
	useGetSpecificFormQuery,
	useAddFormMutation,
	useEditFormMutation,
	useDeleteFormMutation,
	useGetAllformsSubmissionQuery,
	useGetSingleFormSubmissionQuery,
	useCreateFormSubmissionVersionMutation,
	useCreateSupervisorFormSubmissionMutation,
} = FormsApi;
